import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { AgreementsService } from "../../../_services/agreements.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { ProlongingsAgreement } from "../../../_models/prolongings/prolongingsagreement";
import { Http } from "@angular/http";
import { ServiceOffer } from "../../../_models/serviceoffer";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { StatisticsService } from '../../../_services/statistics.service';
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CookieService, CookieOptions } from 'ngx-cookie';
import { Subscription } from "rxjs";
import { Observable } from "rxjs";
import {
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { ExtendOfferOption, ExtendOption } from "app/_models/extendOffer";
import { Car } from "app/_models";
import { UserService } from "app/_services";
import { DealersService } from "app/_services/dealers.service";
import { MatrixCalculatorService } from "app/_services/matrix/matrix-calculator.service";
import { MatrixCarService } from "app/_services/matrix/matrix-cars.service";
import { Dealer } from "app/_models/dealer";
import { differenceInDays, differenceInYears } from "date-fns";

// import { SelectedOptions } from "app/_models/used-cars/matrix-price";

@Component({
  selector: "app-prolongings-calculator",
  templateUrl: "./calculator.component.html",
  providers: [
    AgreementsService,
    CustomersService,
    DealersService,
    MatrixCalculatorService,
    MatrixCarService,
    ServiceOffersService,
    ServiceAddonsService,
    StatisticsService,
    CookieService,
  ],
})
export class ProlongingsCalculatorComponent implements OnInit {
  public showMain: boolean = false;
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  public hasResponded: boolean = false;
  public usedcar: Car;

  private regnr: string = "";
  private useCarId: string = "";
  private dealercalc: boolean;
  private customerid: string = "";
  private mauticId: string = "";
  private dealer: Dealer;

  private errorMessage: string = "";
  private isLoading: boolean = true;
  private calcStartupCost: boolean = true;

  private extendOptions: ExtendOfferOption[] = [];
  public kmSelected: number = 15000;
  public yearSelected: string = "5";
  public completedData;
  public kmLastSelected: number = 15000;
  public yearLastSelected: string = "5";
  public kmPerYearEstimate: number;

  private mauticCustomer: any;
  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number = 0;
  public agree: ProlongingsAgreement;
  private subscription: Subscription;
  private service_price: number;
  private startDate: Date;
  private newAgreementKms: number;
  private estimatedKms: number;

  public agreementStartDate: Date;

  public options: any = {
    yearStep: [1],
    kmStep: [],
  };
  private cookieService: CookieService;
  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  private showSearchByReg: boolean = true;
  public dealerid: string = "";
  public contactDealerAlert: boolean = false;

  public cantCalculateModalRef: NgbModalRef;
  @ViewChild("cantCalculateModalTemplate") modalCantCalculate: TemplateRef<any>;

  constructor(
    toasterService: ToasterService,
    private activatedRoute: ActivatedRoute,
    private agreementsService: AgreementsService,
    private customersService: CustomersService,
    cookieService: CookieService,
    private dealerService: DealersService,
    private matrixCalculatorService: MatrixCalculatorService,
    private matrixCarService: MatrixCarService,
    private modalService: NgbModal,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private statisticsService: StatisticsService,
    private userService: UserService
  ) {
    this.toasterService = toasterService;
    this.cookieService = cookieService;
  }

  addDays(date1: Date, days: number): Date {
    const newDate = new Date(date1.getTime());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  ngOnInit() {
    this.isLoading = true;
    var getIsadmin;
    var did;
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        getIsadmin = this.userService.getIsadmin();
        this.mauticId = param["id"];
        if (param["dealerId"] != null) {
          this.dealerid = param["dealerId"];
        }
        this.customerid = param["custId"];
        this.regnr = param["regnr"];

        this.dealercalc = param["dealercalc"] == "true";
        if (param["regsearch"] && param["regsearch"] == "false") {
          this.showSearchByReg = false;
        }

        this.getCustomer(this.mauticId, this.customerid, this.dealerid).subscribe(
          (c) => {
            this.customer = c;
            this.useCarId = c.usedCarId;
            if (c.regnr != null && c.regnr != "") {
              this.regnr = c.regnr.toString();
            }

            if ((this.customer.regnr == null || this.customer.regnr == "") && (this.regnr != null && this.regnr != "")) {
              this.customer.regnr = this.regnr;
              this.customersService.update(this.customer);
            }

            if (!this.customerid) { this.customerid = this.customer._id };
            this.dealerid = did = this.dealerid != "" ? this.dealerid : c.dealer[0].toString();
          },
          (e) => {
            this.errorMessage = e;
          },
          () => {
            let statisticEvent: StatisticEvent = new StatisticEvent();
            statisticEvent.customer = this.customer._id;
            statisticEvent.event = "prolonging_lp_visit";
            this.payment_method = this.customer.dealer[0].payment_method;
            this.statisticsService
              .sendEvent(statisticEvent)
              .subscribe(
                /* happy path */ r => { console.log('prolonging landingpage visit event tracked'); },
                /* error path */ e => { this.errorMessage = e });
            this.matrixCarService.getCar(this.useCarId).subscribe(
              (c) => {
                this.usedcar = c;
                this.kmSelected = this.usedcar.kmPerService;
                this.carname =
                  c.carmake + " " + c.carmodel + " " + c.carversion;
              },
              (e) => (this.errorMessage = e)
            );
            this.dealerService.get(did).subscribe(
              (d) => {
                this.dealer = d;
                this.payment_method = d.payment_method;
              },
              (e) => (this.errorMessage = e),
              () =>
                this.customersService
                  .queryFromMautic(237, this.dealerid, {
                    attributeName: "regnr",
                    attributeValue: this.regnr,
                  })
                  .subscribe(
                    (customer) => {
                      this.mauticCustomer = customer;

                      //Fix customer object if missing data
                      if (this.customer.firstreg == null) {
                        this.customer.firstreg = this.mauticCustomer.firstreg;
                        this.customersService.update(this.customer);
                      }
                      this.isLoading = false;
                      this.calculateEstimatedKms();
                      this.isCarTooOld(this.mauticCustomer.firstreg);
                      this.startDate = this.addDays(
                        new Date(this.mauticCustomer.agreementExpiration),
                        1
                      );
                    },
                    (e) => (this.errorMessage = e),
                    () =>
                      this.matrixCalculatorService
                        .getAgreementLengths({
                          carId: this.useCarId,
                          agreementStartDate: this.startDate,
                          firstreg: new Date(this.mauticCustomer.firstreg),
                          maxKms: this.dealer.maxKms,
                          carKms: this.estimatedKms,
                          selectedKms: this.kmSelected,
                          maxLength: this.dealer.maxYears,
                          showPartialYears: false,
                          untilDate: new Date(
                            this.mauticCustomer.agreementExpiration
                          ),
                          currentAgreementKms: this.estimatedKms,
                        })
                        .subscribe(
                          /* happy path */(p) => {
                            this.options.yearStep = p.ages;
                            this.yearSelected = p.ages.length
                              ? p.ages[p.ages.length - 1].toString()
                              : null;
                          },
                          /* error path */(e) => {
                            this.errorMessage = e;
                          },
                          () => {
                            this.updateAvailableKms();
                          }
                        )
                  )
            );
            this.serviceAddonsService
              .getDealer(this.dealerid, "prolongings")
              .subscribe(
                /* happy path */(p) => (this.serviceaddons = p),
                /* error path */(e) => (this.errorMessage = e),
                /* onComplete */() => {
                  for (var i = 0; i < this.serviceaddons.length; i++) {
                    this.serviceaddons[i].selected = false;
                  }
                }
              );
          }
        );
      }
    );
  }

  calculateEstimatedKms() {
    console.log(this.mauticCustomer);
    const carAgeInMonths =
      differenceInDays(
        this.mauticCustomer.lastServiceDate,
        this.mauticCustomer.firstreg
      ) / 30.5;
    const kmPerMonth = this.mauticCustomer.carkms / carAgeInMonths;
    const contractLength =
      differenceInDays(
        this.mauticCustomer.agreementExpiration,
        this.mauticCustomer.firstreg
      ) / 30.5;
    const estimatedKms = parseInt((contractLength * kmPerMonth).toFixed(0));
    const carAgeInYears =
    differenceInDays(
      this.mauticCustomer.lastServiceDate,
      this.mauticCustomer.firstreg
    ) / 365;
    const kmPeryear = this.mauticCustomer.carkms / carAgeInYears;
    let calc = estimatedKms % (this.usedcar.kmPerService/3);
    let aux = estimatedKms;
    while (calc !== 0) {
      aux = aux + 1;
      calc = aux % (this.usedcar.kmPerService/3);
    };
    this.estimatedKms = aux;
    this.kmPerYearEstimate = Math.round(kmPeryear);
    //console.log(this.estimatedKms);
    //console.log(this.kmPerYearEstimate);
  }

  updateAvailableYears() {
    this.options.yearStep = [];
    this.matrixCalculatorService
      .getAgreementLengths({
        carId: this.useCarId,
        agreementStartDate: this.startDate,
        firstreg: new Date(this.mauticCustomer.firstreg),
        maxLength: this.dealer.maxYears,
        maxKms: this.dealer.maxKms,
        carKms: this.estimatedKms,
        selectedKms: this.kmSelected,
        showPartialYears: false,
        untilDate: new Date(this.mauticCustomer.agreementExpiration),
        currentAgreementKms: this.estimatedKms,
      })
      .subscribe(
        /* happy path */(p) => {
          this.options.yearStep = p.ages;

          if (p.ages.length)
            this.yearSelected = p.ages.find(
              (length) => `${length}` === this.yearSelected
            )
              ? this.yearSelected
              : `${p.ages[p.ages.length - 1]}`;
        },
        /* error path */(e) => {
          this.errorMessage = e;
        },
        () => this.calculatePrice()
      );
  }

  updateAvailableKms() {
    this.options.kmStep = [];
    this.matrixCalculatorService
      .getAgreementKms({
        carId: this.useCarId,
        agreementStartDate: this.startDate,
        firstreg: new Date(this.mauticCustomer.firstreg),
        maxKms: this.dealer.maxKms,
        carKms: this.estimatedKms,
        showPartialYears: false,
        untilDate: new Date(this.mauticCustomer.agreementExpiration),
        currentAgreementKms: this.estimatedKms,
        maxLength: this.dealer.maxYears,
      })
      .subscribe(
        (p) => {
          this.options.kmStep = p.kms;
          if (p.kms.length)
            this.kmSelected = p.kms.find(
              (kms) => Number(kms) === Number(this.kmSelected)
            )
              ? this.kmSelected
              : p.kms[0];
          if (
            this.options.kmStep.length <= 1 &&
            this.contactDealerAlert == false
          ) {
            this.calculatedPrice = 0;
            this.showCantCalculateModal();
            this.contactDealerAlert = true;
          }
        },
        (e) => (this.errorMessage = e),
        () => this.calculatePrice()
      );
  }

  updateSelectedKms(event: number) {
    this.kmSelected = event;
    this.updateAvailableYears();
  }

  updateSelectedYear(event: string) {
    this.yearSelected = event;
    this.updateAvailableKms();
  }

  isCarTooOld(reg: number) {
    var yearTooOld = new Date().getFullYear() - 10;
    var regYear = new Date(reg).getFullYear();
    //alert(firstreg.getFullYear());
    if (yearTooOld >= regYear && this.contactDealerAlert == false) {
      this.calculatedPrice = 0;
      this.showCantCalculateModal();
      this.contactDealerAlert = true;
    }
  }

  calculatePrice() {
    let statisticEvent: StatisticEvent = new StatisticEvent();
    statisticEvent.customer = this.customer._id;
    statisticEvent.event = "prolonging_lp_calculator_date";
    this.statisticsService
      .sendEvent(statisticEvent)
      .subscribe(
	      /* happy path */ r => { console.log('prolonging landingpage calculator event tracked'); },
	      /* error path */ e => { this.errorMessage = e; this.isLoading = false; });

    this.matrixCalculatorService
      .getProlongingsMonthlyPrice(
        this.useCarId,
        this.yearSelected,
        this.kmSelected,
        new Date(this.mauticCustomer.agreementExpiration),
        new Date(this.mauticCustomer.firstreg),
        this.estimatedKms
      )
      .subscribe(
        /* happy path */(p) => {
          this.calculatedPrice = p.monthlyPrice;
          this.completedData = p;
        },
        /* error path */(e) => {
          this.errorMessage = e;
        },
        /* onComplete */
        () => {
          let newPrice: number;

          newPrice = this.calculatedPrice;
          this.serviceaddonslist = [];
          for (var i = 0; i < this.serviceaddons.length; i++) {
            if (this.serviceaddons[i].selected) {
              newPrice += this.serviceaddons[i].price;
              this.serviceaddonslist.push(this.serviceaddons[i]);
            }
          }
          this.calculatedPrice = newPrice;
        }
      );
  }

  monthDiff(d1, d2): number {
    return this.getMonthsBetween(d1, d2, false);
  }

  getMonthsBetween(date1, date2, roundUpFractionalMonths) {
    //Months will be calculated between start and end dates.
    //Make sure start date is less than end date.
    //But remember if the difference should be negative.
    var startDate = date1;
    var endDate = date2;
    var inverse = false;
    if (date1 > date2) {
      startDate = date2;
      endDate = date1;
      inverse = true;
    }

    //Calculate the differences between the start and end dates
    var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    var monthsDifference = endDate.getMonth() - startDate.getMonth();
    var daysDifference = endDate.getDate() - startDate.getDate();

    var monthCorrection = 0;
    //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
    //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
    if (roundUpFractionalMonths === true && daysDifference > 0) {
      monthCorrection = 1;
    }
    //If the day difference between the 2 months is negative, the last month is not a whole month.
    else if (roundUpFractionalMonths !== true && daysDifference < 0) {
      monthCorrection = -1;
    }

    return (
      (inverse ? -1 : 1) *
      (yearsDifference * 12 + monthsDifference + monthCorrection)
    );
  }
  showCantCalculateModal(): void {
    this.cantCalculateModalRef = this.modalService.open(
      this.modalCantCalculate
    );
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }

  getCustomer(mauticId: string, customerId: string, dealerId: string): Observable<Customer> {
    if (mauticId != null) {
      return this.customersService.getCustomerByMauticIdent(mauticId, dealerId)
    }
    else {
      return this.customersService.get(customerId);
    }
  }

  gotoCheckout(): void {
    if (this.kmSelected == null) {
      alert("Vælg kilometer");
      return;
    }
    let newItem: Partial<ProlongingsAgreement> = {};
    newItem.car = [this.usedcar];
    newItem.customer = this.customerid;
    newItem.years = this.yearSelected + "";
    newItem.km = this.kmSelected + "";
    newItem.addons = this.serviceaddonslist;
    newItem.price = this.calculatedPrice;
    newItem.service_price = this.service_price;
    newItem.payout = this.startupPrice;
    newItem.actualkm = this.mauticCustomer.carkms;
    newItem.lastservice = this.mauticCustomer.agreementStartDate;
    newItem.customerAccept = this.mauticCustomer.micar_agreement_acceptanc;
    newItem.currentServiceAgreementExpiration =
      this.mauticCustomer.agreementExpiration;
    newItem.currentServiceAgreementKilometers =
      this.mauticCustomer.agreementKilometers;
    sessionStorage.setItem("prolongingsAgree", JSON.stringify(newItem));
    sessionStorage.setItem("completedData", JSON.stringify(this.completedData));

    if (this.serviceaddons.length > 0) {
      top.window.location.href =
        "/#/prolongings/order-flow/additional-products/" +
        this.customerid +
        "?regsearch=" +
        (this.showSearchByReg ? "true" : "false") +
        (this.dealercalc ? "&dealercalc=true" : "");
    } else {
      top.window.location.href =
        "/#/prolongings/order-flow/checkout/" +
        this.customerid +
        "?regsearch=" +
        (this.showSearchByReg ? "true" : "false") +
        (this.dealercalc ? "&dealercalc=true" : "");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/prolongings/order-flow/calculator.component.ts